import {DataDogEnvsEnum} from 'presentation/constants/dataDogEnvsEnum';

const isHmlEnvironment = process.env.DD_ENVIRONMENT === DataDogEnvsEnum.HML;

const withEnvironmentFormUrl = (urls: {formUrlProd: string; formUrlHml: string}) => ({
	...urls,
	formUrl: isHmlEnvironment ? urls.formUrlHml : urls.formUrlProd,
});

export const CHANNELS_CONTACTS = {
	HAPVIDA: {
		CALL_CENTER: {
			phone1: '40023633',
			phone2: '40203633',
			phone3: '03003133633',
		},
		APPOINTMENTS_EXAMS: {
			NO_NE: {
				phone1: '40023633',
				phone2: '40203633',
				phone3: '03003133633',
			},
			S_SE_CO: {
				phone1: '40201889',
				phone2: '03007893650',
			},
		},
		SAC: {
			NO_NE: {
				phone1: '08002809130',
			},
			S_SE_CO: {
				phone1: '08000183456',
			},
			ODONTO: {
				phone1: '08002759092',
			},
		},
		OMBUDSMAN: {
			phone1: '40209091',
			formUrl: 'https://www.hapvida.com.br/site/ouvidoria-formulario',
		},
		CANCELLATION: {
			phone1: '08000183456',
		},
		SALES: {
			phone1: '08007779070',
		},
	},
	CLINIPAM: {
		APPOINTMENTS_EXAMS: {
			CAPITAL_METROPOLITAN: {
				phone1: '40902790',
			},
			OTHER_LOCATIONS: {
				phone1: '08008002790',
			},
		},
		CENTRAL_SERVICE: {
			CAPITAL_METROPOLITAN: {
				phone1: '40902780',
			},
			OTHER_LOCATIONS: {
				phone1: '08008002780',
			},
			INTERODONTO: {
				phone1: '03007724000',
			},
		},
		SAC: {
			phone1: '08005453001',
		},
	},
	NDI_MINAS: {
		APPOINTMENTS_EXAMS: {
			CAPITAL_METROPOLITAN: {
				phone1: '40902290',
				phone2: '40902210',
			},
			OTHER_LOCATIONS: {
				phone1: '08008002290',
			},
		},
		CENTRAL_SERVICE: {
			CAPITAL_METROPOLITAN: {
				phone1: '40902210',
			},
			OTHER_LOCATIONS: {
				phone1: '08008002210',
			},
		},
		SAC: {
			phone1: '08008003012',
		},
	},
	CCG: {
		CENTRAL_SERVICE: {
			phone1: '08009429601',
		},
		SAC: {
			phone1: '08006479600',
		},
		APPOINTMENTS_EXAMS: {
			phone1: '5123121505',
		},
	},
	NDI_SAO_PAULO: {
		CALL_CENTER: {
			phone1: '40901750',
			phone2: '08004091750',
			infinity: '08004634648',
			tpda: '08007700330',
			accredited: '08004674634',
			saintLuke: '40901153',
		},
		APPOINTMENTS_EXAMS: {
			phone1: '40901740',
			phone2: '08004091740',
			others: '40901680',
			saintLuke: '4090-1005',
		},
		SAC: {
			phone1: '08000153855',
			saintLuke: '08007708980',
		},
		OMBUDSMAN: withEnvironmentFormUrl({
			formUrlProd: 'https://gndi.com.br/ouvidoria',
			formUrlHml: 'https://hml-institucional.gndi.com.br/ouvidoria',
		}),
	},
	NOTREDAME_SAUDE: {
		CALL_CENTER: {
			phone1: '40049057',
			phone2: '08008501157',
			infinity: '08004634648',
			tpda: '08007700330',
			accredited: '08004674634',
			saintLuke: '40901153',
		},
		SAC: {
			phone1: '08008500087',
			saintLuke: '08007708980',
		},
		OMBUDSMAN: withEnvironmentFormUrl({
			formUrlProd: 'https://www.notredame.com.br/ouvidoria',
			formUrlHml: 'https://hml-institucional.notredame.com.br/ouvidoria',
		}),
		FINANCIAL_SUPPORT: '08007700168',
	},
};

export const FINANCIAL_SUPPORT_PHONE = '08007700241';
export const FINANCIAL_SUPPORT_PHONE_PPO = '08007700168';
export const FINANCIAL_SUPPORT_WHATSAPP_LINK = 'https://wa.me/5508007700241';
export const FINANCIAL_SUPPORT_WHATSAPP_LINK_PPO = 'https://wa.me/5508007700168';
